import { Loader } from 'components'
import * as React from 'react'
import { StripeProvider } from 'react-stripe-elements'
import { Elements } from 'react-stripe-elements'
import { _route } from '../../routes/config'
import Checkout from './checkout'
import './style.scss'

interface IProps {
  goToCongratulationsTab: () => void
  parentId: string
}

export const PaymentComponent: React.FC<IProps> = ({
  goToCongratulationsTab,
  parentId
}: IProps) => {
  const [loading, setLoading] = React.useState(false)

  return (
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY || ''}>
      <div className="">
        <Loader loading={loading} text="Processing your payment" />
        <Elements>
          <Checkout
            setLoading={setLoading}
            goToCongratulationsTab={() => {
              goToCongratulationsTab()
            }}
            parentId={parentId}
          />
        </Elements>
      </div>
    </StripeProvider>
  )
}



// WEBPACK FOOTER //
// ./src/components/PaymentComponent/index.tsx